export enum NIM_AUTH_TYPE{
  SIGNIN,
  SIGNUP,
  REMOVE
}

export interface INimDevice {
  globalId: string;
  fingerprint?: string;
}

export interface INimLoginParams {
  login: string;
  password: string;
  device?: INimDevice;
}

export interface INimLoginResponse {
  sessionId: string;
  id?: number;
  errorCode?: number;
  body?: any;
}

export interface INimRegisterParams {
  login: string;
  password: string;
  username?: string;
  firstname?: string;
  lastname?: string;
  service?: string;
  languages?: string[];
  device?: INimDevice;
}

export interface INimRegisterResponse {
  sessionId: string;
  id?: number;
  errorCode?: number;
  body?: any;
}

export interface INimRestoreParams {
  login: string;
}

export enum NIM_AUTH_ERRORS{
  LOGIN_REQUIRED,
  LOGIN_INCORRECT,
  PASSWORD_REQUIRED,
  PASSWORD_MIN,
  LOGIN_WRONG_DATA,
  REGISTRATION_WRONG_DATA,
  EXISTED_EMAIL,
  CODE_REQUIRED,
  WRONG_CODE,
  CODE_ONLY_NUMBERS,
  CODE_SIX_NUMBERS,
}

export interface INimChallengeParams {
  state: string,
  answer: string,
}
